export const enum NegotiationManualCancelReason {
    BETTER_ALTERNATIVE = 1,
    CLIENT_UNDESIRED = 2,
    NOT_DISCLOSED = 3
}

/**
 * API request parameters for starting a negotiation
 */
export interface NegotiationStartRequest {
    estimated_price: number;
    fair_price: number;
    minimum_acceptance: number;
    target_price: number;
    bad_situation: boolean;
    good_situation: boolean;
    auto_respond: boolean;
    user_own_name: boolean;
    vehicle_auto_nego_session_id: number;
    min_accept: number;
    local_nego?: boolean;
    freight_exchange_format?: boolean;
    auto_send_initial?: boolean;
    ltl_applied?: boolean;
    use_messenger?: boolean;
}

export const manualCancelReasonToString = (reason: NegotiationManualCancelReason) => {
  switch(reason) {
    case NegotiationManualCancelReason.BETTER_ALTERNATIVE:
      return 'found a better alternative';
    case NegotiationManualCancelReason.CLIENT_UNDESIRED:
      return 'do not wish to work with this customer';
  }
  return 'no reason disclosed';
};

export interface NegotiationEmailBody {sender: 'CLIENT' | 'MANAGER' | 'AI', body: string, aiJustification?: string, riskLevel?: 'low' | 'medium' | 'high', at: number, offeredPrice: number | null, sent: boolean}

/**
 * Negotiation information
 */
export interface Negotiation {
    id?: string;
    offer_id: number;
    vehicle_id: number;
    emailMessageIds?: string[];
    repliedToMessagesIds?: string [];
    emailSubject?: string;
    emailBodies?: NegotiationEmailBody[];
    firstContactTime?: Date;
    lastContactTime?: Date;
    fairPrice?: number; //including the surcharges for this truck
    createdAt?: Date; //active negotiation for an offer is the most recent one
    initiallyOfferedPrice?: number; //price client proposed after our mail
    lastOfferedPrice?: number; //last price we're proposed after which client said no or stop answering
    targetPrice?: number; //floor price corresponding to company desired price, the fairPrice + a rate or a percentage
    badSituation?: boolean; //whether bad situation for the truck, so can negotiate between fairPrice and targetPrice
    goodSituation?: boolean; //whether good situation for the truck, so should delay responses and raise higher
    emailNego: boolean;
    autoRespond?: boolean; //whether to auto send emails or not
    starting_user_id?: number; //user who started the negotiation
    manualCancelReason?: NegotiationManualCancelReason;
    vehicle_auto_nego_session_id?: number; //if set, the negotiation was started from a vehicle auto-negotiation session
    minimumAcceptancePrice?: number; //minimum price we can accept after 2 round
    hasUnsent?: boolean; //computed field to know if there is unsent emails in the negotiation
    useMessenger?: boolean; //true when messages are dispatched via the marketplace plugin messenger instead of email
}